import * as React from 'react'
import { PopupLink } from '../../PopupWindow'
import {
  getViewTransactionDetailHref,
} from '../../../Helper/util'

interface ResponseInformationProps {
  title?: string
  approvalCode?: string
  responseMessage: string
  orderId: string
  amountDisplay?: React.ReactNode
  actionButtons?: React.ReactNode
}

export function ResponseInformation ({
  title = 'Approval Information:',
  approvalCode,
  responseMessage,
  orderId,
  amountDisplay,
  actionButtons,
  children,
}: React.PropsWithChildren<ResponseInformationProps>) {
  const isPending = orderId === 'pending'
  const transactionId = Number(orderId)

  const linkText: string = 'View Transaction Details'
  const hrefValue: string = getViewTransactionDetailHref(transactionId)

  return (
    <div>
      <div className="response-info-header">
        {amountDisplay}
        <div className="response-info-link">
          {isPending
            ? (
              <span title="Order ID is being derived, you do not need to wait here while it processes, but will see it appear as it does.">
                pending
              </span>
              )
            : (
              <PopupLink href={hrefValue}>{linkText}</PopupLink>
              )}
        </div>

        {actionButtons && (
          <div className="response-info-actions">
            {actionButtons}
          </div>
        )}
      </div>

      <h3 className="response-info-title">{title}</h3>

      <table className="response-info-table">
        <tbody>
        {children}

        {approvalCode && (
          <tr>
            <td className="response-info-label"><strong>Approval&nbsp;Code:</strong></td>
            <td className="uid-tranx-app-approval-code">{approvalCode}</td>
          </tr>
        )}

        <tr>
          <td className="response-info-label"><strong>Response:</strong></td>
          <td className="uid-tranx-app-response">{responseMessage}</td>
        </tr>

        <tr>
          <td className="response-info-label"><strong>Order&nbsp;ID:</strong></td>
          <td className="uid-tranx-app-order-id">{orderId}</td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}
